module.exports = __webpack_public_path__ + "img/Conversion rate Icon - charcoal.213c5de2.svg";